import {TrackAppBanner, useTrackFeature} from '@aboutyou/tracking';
import {
  AppDetails,
  InstallBanner,
  InstallBannerProps,
} from '@aboutyou/ui-components';
import React from 'react';
import {HeaderInstallBannerWrapper} from './HeaderInstallBannerWrapper';

export type TrackInstallBannerProps = Pick<
  InstallBannerProps,
  'fallbackLabel' | 'isInstalled' | 'goToAppLabel'
> &
  AppDetails & {
    isLoading: boolean;
    onClose: (options?: {
      disableAnimation?: boolean;
      setLastTimeClosed?: boolean;
    }) => void;
  };

const TRACK_FEATURE_LABEL = 'app_banner';

export function TrackedInstallBanner({
  onClose,
  ...props
}: TrackInstallBannerProps) {
  const trackFeature = useTrackFeature();

  const handleImpression = () => {
    trackFeature({eventType: 'impression', label: TRACK_FEATURE_LABEL});
  };

  const handleOnClose = () => {
    onClose({
      setLastTimeClosed: true,
    });
    trackFeature({eventType: 'close', label: TRACK_FEATURE_LABEL});
  };

  const handleOnCTAClicked = () => {
    trackFeature({eventType: 'click', label: TRACK_FEATURE_LABEL});
  };

  return (
    <TrackAppBanner
      Comp={HeaderInstallBannerWrapper}
      data-testid="installBanner-container"
      onImpressionTracked={handleImpression}
    >
      <InstallBanner
        {...props}
        onAppClick={handleOnCTAClicked}
        onClose={handleOnClose}
      />
    </TrackAppBanner>
  );
}
